import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  VStack,
  Box,
  Text,
  useColorModeValue as mode,
  Spinner,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import axios from "axios";
import JobCard from "./JobCard";

const CustomerHistoryModal = ({ isOpen, onClose, customerName, customerId }) => {
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [customerJobs, setCustomerJobs] = useState([]);

  useEffect(() => {
    if (isOpen && customerId) {
      const fetchCustomerJobs = async () => {
        setLoading(true);
        try {
          console.log("Fetching jobs for customer ID:", customerId);
          const { data } = await axios.get(`/api/jobs/customer/${customerId}`);
          console.log("Received jobs:", data.jobs);
          setCustomerJobs(data.jobs || []);
        } catch (error) {
          console.error("Error fetching customer jobs:", error);
          toast({
            title: "Error",
            description: "Failed to load customer history",
            status: "error",
            duration: 3000,
          });
          setCustomerJobs([]);
        } finally {
          setLoading(false);
        }
      };
      fetchCustomerJobs();
    }
  }, [isOpen, customerId, toast]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size='lg' scrollBehavior='inside'>
      <ModalOverlay />
      <ModalContent maxH='90vh'>
        <ModalHeader>Customer History: {customerName}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          {loading ? (
            <Box display='flex' justifyContent='center' alignItems='center' minH='200px'>
              <Spinner size='lg' />
            </Box>
          ) : customerJobs.length === 0 ? (
            <Box bg={mode("gray.50", "gray.700")} p='6' borderRadius='md' textAlign='center'>
              <Text color={mode("gray.600", "gray.300")}>No jobs found for this customer</Text>
            </Box>
          ) : (
            <VStack spacing='4' align='stretch'>
              {customerJobs.map((job) => (
                <JobCard key={job.JOB_NO} job={job} loading={false} listType='history' />
              ))}
            </VStack>
          )}
        </ModalBody>
        <ModalFooter>
          <Button colorScheme='blue' mr={3} onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CustomerHistoryModal;
